// Campus photo for /colleges/university-of-idaho: CC BY-SA 3.0, by Davidlharlan, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Idaho_Administration_Building_-_east_side.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-idaho/; credited under the photo.
const photo = {
    "slug": "university-of-idaho",
    "alt": "The red brick Administration Building with its clock tower and arched entrance at the University of Idaho in Moscow, Idaho",
    "src": "/colleges/university-of-idaho/campus-1600.webp",
    "srcSmall": "/colleges/university-of-idaho/campus-800.webp",
    "srcMid": "/colleges/university-of-idaho/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-idaho/og.jpg",
    "title": "University of Idaho Administration Building - east side",
    "author": "Davidlharlan",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Idaho_Administration_Building_-_east_side.jpg",
    "read": "2026-10-01"
};

export default photo;
